import { apiResourceUrl } from "@ploy-lib/core";
import { BaseCamelCasedResource } from "./BaseResource";
export var PasswordPolicyTimeUnit;
(function (PasswordPolicyTimeUnit) {
    PasswordPolicyTimeUnit["Minute"] = "minute";
    PasswordPolicyTimeUnit["Hour"] = "hour";
    PasswordPolicyTimeUnit["Day"] = "day";
    PasswordPolicyTimeUnit["Week"] = "week";
    PasswordPolicyTimeUnit["Month"] = "month";
    PasswordPolicyTimeUnit["Year"] = "year";
})(PasswordPolicyTimeUnit || (PasswordPolicyTimeUnit = {}));
export class PasswordPolicyResource extends BaseCamelCasedResource {
    pk() {
        return "singleton";
    }
    static url(urlParams) {
        return this.listUrl(urlParams);
    }
}
PasswordPolicyResource.urlRoot = apiResourceUrl("password-policy");
//# sourceMappingURL=PasswordPolicyResource.js.map